/**
 * Redeems an invite link's code kept through sign-up (`D275`), once, the
 * first time the app is open signed in. Success says so in a toast; a
 * refusal (an old account, one's own code, a second inviter) says nothing —
 * the person did not ask for anything, and the kept code is forgotten
 * either way. Mounted once inside the gate, like `WarmLayers`.
 */
import { redeemInvite } from "@repo/client/data/community";
import { "invite.redeemed" as redeemedText } from "@repo/i18n";
import { useEffect } from "react";
import { useApi } from "../../data/api";
import { useToast } from "../../ui/overlay";
import { takePendingInvite } from "./landing";

export function PendingInviteDoor() {
  const api = useApi();
  const { notify } = useToast();
  useEffect(() => {
    let cancelled = false;
    takePendingInvite()
      .then((code) => (code === null ? null : redeemInvite(api, code)))
      .then(
        (redeemed) => {
          if (!cancelled && redeemed !== null) {
            notify({ message: redeemedText() });
          }
        },
        () => undefined
      );
    return () => {
      cancelled = true;
    };
  }, [api, notify]);
  return null;
}
